import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTitleListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#000"
      d="M6 8H4.668a.667.667 0 1 0 0 1.333h1.334A.667.667 0 0 0 6 8m-.666-1.333h2.667a.667.667 0 0 0 0-1.334H5.334a.667.667 0 0 0 0 1.334m.667 4H4.667a.667.667 0 1 0 0 1.333h1.334a.666.666 0 1 0 0-1.333M14 8h-2V2a.668.668 0 0 0-1-.58L9 2.567 7 1.42a.67.67 0 0 0-.667 0l-2 1.147-2-1.147a.667.667 0 0 0-1 .58v10.667a2 2 0 0 0 2 2h9.333a2 2 0 0 0 2-2v-4A.667.667 0 0 0 14.001 8M3.334 13.333a.667.667 0 0 1-.667-.666V3.153l1.334.76a.72.72 0 0 0 .666 0l2-1.146 2 1.146a.72.72 0 0 0 .667 0l1.333-.76v9.514a2 2 0 0 0 .12.666zm10-.666a.666.666 0 1 1-1.333 0V9.333h1.333zM9.041 10.78a.5.5 0 0 0-.12-.06.668.668 0 0 0-.727.14.7.7 0 0 0-.193.473.7.7 0 0 0 .046.254.8.8 0 0 0 .147.22q.099.089.22.14a.63.63 0 0 0 .507 0 .8.8 0 0 0 .22-.14.67.67 0 0 0 .193-.474.7.7 0 0 0-.193-.473 1 1 0 0 0-.1-.08m.093-2.587a.667.667 0 0 0-1.127.54.667.667 0 0 0 1.132.405.67.67 0 0 0 .195-.471.7.7 0 0 0-.053-.254.6.6 0 0 0-.147-.22"
    />
  </svg>
);
export default SvgTitleListIcon;
